import React from 'react';

import { MultiSelectDisplay } from "../../components"

const SecondaryInformation = ({ user }) => {
    if (!user) {
        return <></>
    }

    return (
        <div className="extended-information">
            <h5>Work expertise</h5>
            <MultiSelectDisplay options={user.expert_categories} />

            <h5>Interests</h5>
            <MultiSelectDisplay options={user.interest_categories} />
        </div>
    )
};

export default SecondaryInformation;
